import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import useSWR from 'swr';
import { fetcher } from '../../services/api';
import { useCurrentUser } from '../current-user';

export const RetailOverdueReminder = () => {
  const { profile, isAdmin } = useCurrentUser();
  const { data: count } = useSWR<number>(
    isAdmin ? ['/delivery-order/retail-overdue-count', profile.id] : null,
    ([url]) => fetcher(url),
    {
      refreshInterval: 60_000,
      revalidateOnFocus: true,
    },
  );

  if (!isAdmin || !count) return null;

  return (
    <div
      className="alert alert-warning d-flex flex-wrap align-items-center gap-2 mb-3"
      role="status"
      aria-live="polite"
    >
      <span>
        <FormattedMessage
          id="retailOverdueReminder.message"
          defaultMessage="В «Рознице» есть заказы, ожидающие обработки более суток: {count}."
          description="Постоянное напоминание администраторам о розничных заказах"
          values={{ count }}
        />
      </span>
      <Link to="/deliveries/orders/retail" className="alert-link">
        <FormattedMessage
          id="retailOverdueReminder.openOrders"
          defaultMessage="Посмотреть заказы"
          description="Ссылка на все розничные заказы"
        />
      </Link>
    </div>
  );
};
